var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffordable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11320",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11603",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11604",
    d: "M6 21H4a1 1 0 01-1-1v-6a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11605",
    d: "M13 17h2.333a2 2 0 001.2-.4l2.416-1.812a1.515 1.515 0 011.98.141h0a1.514 1.514 0 010 2.142l-2.073 2.073a4 4 0 01-2.044 1.094l-2.93.586a4 4 0 01-1.755-.042l-2.65-.662a3.957 3.957 0 00-.969-.12H7",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11606",
    d: "M13 17h1.485A1.515 1.515 0 0016 15.485v-.3a1.514 1.514 0 00-1.147-1.469l-2.292-.573A4.705 4.705 0 0011.422 13h0a4.69 4.69 0 00-2.605.789L7 15",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11607",
    d: "M17.169 5.155a2.838 2.838 0 11-4.014 0 2.838 2.838 0 014.014 0",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11608",
    d: "M14.631 4.375a2.834 2.834 0 10-2.263 3.249",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
export default SvgAffordable;


//////////////////
// WEBPACK FOOTER
// ./src/icons/affordable.svg
// module id = 173
// module chunks = 13